
import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, withStyles } from '@material-ui/core';
import styles from '../styles';
import { useDispatch } from "react-redux";
import TelegramIcon from '@material-ui/icons/Telegram';
import { Link } from 'react-router-dom';
import { changeFlightNumber, changeDepartureDate } from '../../../store/dcs';

const months = { Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06", Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12" }

const Results = (props) => {
  console.log('results props: ', props)
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const setDcsFilters = (data) => {
    dispatch(changeFlightNumber(data.flightNum))
    // NOTE // format = YYYY-MM-DD
    dispatch(changeDepartureDate(data.date))
  };
  const {results, classes, isMobile, airline} = props;

  const columns = isMobile ? [
    { id: 'lastNameSearch', label: 'Last Name', minWidth: 10 },
    { id: 'firstNameSearch', label: 'First Name', minWidth: 10 },
    { id: 'rlocSearch', label: 'PNR', minWidth: 10 },
    { id: 'dateSearch', label: 'Date', minWidth: 10 },
    { id: 'redirectToDcs', label: 'To DCS', minWidth: 10 }
  ] : [
    { id: 'paxCountSearch', label: 'Pax Count', minWidth: 10 },
    { id: 'lastNameSearch', label: 'Last Name', minWidth: 10 },
    { id: 'firstNameSearch', label: 'First Name', minWidth: 10 },
    { id: 'rlocSearch', label: 'PNR', minWidth: 10 },
    { id: 'departureSearch', label: 'Departure', minWidth: 10 },
    { id: 'arrivalSearch', label: 'Arrival', minWidth: 10 },
    { id: 'dateSearch', label: 'Date', minWidth: 10 },
    { id: 'fltNoSearch', label: 'Flight Number', minWidth: 10 },
    { id: 'redirectToDcs', label: 'To DCS', minWidth: 10 }
  ];

  const createData = isMobile ? 
  (lastNameSearch, firstNameSearch, rlocSearch, dateSearch, redirectToDcs) => {
    return { lastNameSearch, firstNameSearch, rlocSearch, dateSearch, redirectToDcs };
  } : 
  (paxCountSearch, lastNameSearch, firstNameSearch, rlocSearch, departureSearch, arrivalSearch, dateSearch, fltNoSearch, redirectToDcs) => {
    return { paxCountSearch, lastNameSearch, firstNameSearch, rlocSearch, departureSearch, arrivalSearch, dateSearch, fltNoSearch, redirectToDcs };
  };

  const rows = results.filter((res) => res.fltNo.startsWith(airline)).map((res) => {
    function formatDate() {
      const year = res.date.substr(5);
      const month = months[res.date.substr(2, 3)];
      const day = res.date.substr(0, 2);
      return `${year}-${month}-${day}`;
    }

    // Date already formatted correctly on pnr search
    let link = (
      <Link to={'DCS'} style={{textTransform: 'none', textDecoration: 'none'}}>
        <TelegramIcon onClick={() => {setDcsFilters({flightNum: res.fltNo, date: res.pnrSearch ? res.date : formatDate()})}} />
      </Link>
    )

    return isMobile ? 
      createData(res.last, res.first, res.rloc, res.date, link) : 
      createData(res.paxCount, res.last, res.first, res.rloc, res.departure, res.arrival, res.date, res.fltNo, link);
  })

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, backgroundColor: `#404040`, color: `white` }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default withStyles(styles)(Results);